import { ArrowDropDown } from '@mui/icons-material';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Typography,
    alpha,
} from '@mui/material';
import { useSelector } from 'react-redux';

import { CatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { getLocalCategoriesList } from 'entities/Category';
import { getSelectedOrder } from 'entities/Order/model/selectors/ordersSelectors';

import { OrderGroupedItemsTable } from './OrderGroupedItemsTable';

interface OrderGroupedItemsTableProps {
    categoryId: string;
    items: CatalogItem[];
}

export const OrderGroupedItems = ({
    categoryId,
    items,
}: OrderGroupedItemsTableProps) => {
    const categories = useSelector(getLocalCategoriesList);
    const currentOrder = useSelector(getSelectedOrder);

    const title = categories?.[categoryId]?.title;
    const glCode = categories?.[categoryId]?.glCode;
    const color = categories?.[categoryId]?.color;
    const itemsCount = items.length;

    return (
        <Box data-testclass="order-category">
            <Accordion
                defaultExpanded
                sx={{ boxShadow: 'none', borderRadius: '0px !important' }}
            >
                <AccordionSummary
                    sx={(theme) => ({
                        bgcolor: '#E9E8E8',
                        borderRadius: '0px',
                        padding: '14px 12px 14px 20px',
                    })}
                    expandIcon={
                        <ArrowDropDown
                            sx={(theme) => ({
                                color: alpha(theme.palette.common?.black, 0.3),
                            })}
                        />
                    }
                >
                    <Box display="flex" alignItems="center" gap="12px">
                        <Box
                            width="8px"
                            height="8px"
                            borderRadius="50%"
                            overflow="hidden"
                            sx={{ bgcolor: color }}
                        ></Box>
                        <Box display={'flex'}>
                            <Typography
                                typography={'openSans.body2'}
                                data-testclass="order-category-title"
                                sx={{
                                    color: '#000',
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    letterSpacing: '0',
                                }}
                            >
                                {title} {`(${itemsCount})`}
                            </Typography>
                            <Typography
                                sx={(theme) => ({
                                    color: alpha(
                                        theme.palette.common?.black,
                                        0.5,
                                    ),
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    letterSpacing: '0',
                                })}
                                typography={'openSans.body2'}
                            >
                                {glCode ? ` | ${glCode}` : ''}
                            </Typography>
                        </Box>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <OrderGroupedItemsTable
                        items={items}
                        orderStatus={currentOrder?.status}
                    />
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};
